import * as Scrivito from "scrivito";
import activeObjSearch from "^/utils/activeObjSearch";
import NavigationLink from "./NavigationLink";

function NavigationBlock({ mainOverviewPage, pageClass, publishFromDate }) {
  if (!mainOverviewPage) {
    return null;
  }
  const base = () =>
    activeObjSearch()
      .and("_objClass", "equals", pageClass)
      .and("displayOnThisPage", "refersTo", mainOverviewPage);

  const previous = base()
    .and("publishFromDate", "isGreaterThan", publishFromDate)
    .order("publishFromDate", "asc")
    .first();

  const next = base()
    .and("publishFromDate", "isLessThan", publishFromDate)
    .order("publishFromDate", "desc")
    .first();

  return (
    <div className="row justify-content-between mt-4">
      <div className="col-sm-6 text-left">
        <NavigationLink to={previous} direction="left" />
      </div>
      <div className="col-sm-6 text-right">
        <NavigationLink to={next} direction="right" />
      </div>
    </div>
  );
}
export default Scrivito.connect(NavigationBlock);
